export default __webpack_public_path__ + "locales/fr/VersionHistory.json?hash=6ab22d3ab45f07aac97bfc9a4ea6c926";